// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SCIE","largestCol":"styles_largestCol___3N_B","smallestCol":"styles_smallestCol__2ttiF"};